import Image from "next/image";
import React from "react";
import { toWebp } from "@/utils/common";
import MobileSlider from "./mobile-slider";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

interface TechnologyExpertiseProps {
  data?: any;
}

const TechnologyExpertise = ({ data }: TechnologyExpertiseProps) => {
  const cards = (data?.cards?.future_cards || []).map((card: any) => ({
    id: card.id,
    title: card.title,
    tags: (card.description || "")
      .split("|")
      .map((tag: string) => tag.trim())
      .filter(Boolean),
    imageUrl: card?.Image?.data?.attributes?.url,
  }));

  return (
    <section className="relative z-[0] overflow-hidden xl:py-[100px] lg:py-[80px] py-[56px] bg-white after:content-[''] after:absolute after:inset-y-0 after:left-0 after:w-full after:h-full after:bg-[url('/images/bg-enterprise-mobile.png')] md:after:bg-[url('/images/bg-enterprise-ipad.png')] lg:after:bg-[url('/images/bg-enterprise.png')] after:bg-no-repeat after:bg-left after:[background-size:100%_100%] after:-z-0">
      <div className="container mx-auto text-center relative z-10 mb-[50px]">
        <h2 className="text-center xl:text-[48px] xl:leading-[62.4px] lg:text-[40px] lg:leading-[52px] text-[30px] leading-[39px] tracking-[1px] font-bold text-primary-text max-w-[940px] mx-auto w-full">
          {data?.title}
        </h2>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Desktop / Tablet */}
        <div className="sm:block hidden">
          <div className="grid grid-cols-12 gap-[30px]">
            {cards.map((card: any, index: number) => (
              <div
                key={card.id ?? index}
                className={`
      ${
        index === 0
          ? "col-span-12 xl:col-span-8"
          : index === 1
            ? "col-span-6 xl:col-span-4"
            : index === 2
              ? "col-span-6 xl:col-span-4"
              : "col-span-12 xl:col-span-8"
      }
      card-main
    `}
              >
                <div className="relative border-1 h-[517px] border-[rgba(64,66,76,1)] p-[32px_24px] group overflow-hidden">
                  {card.imageUrl && (
                    <Image
                      src={toWebp(`${baseUrl}${card.imageUrl}`)}
                      alt={card.title}
                      width={1000 * 2}
                      height={500 * 2}
                      quality={100}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  )}

                  <div className="absolute inset-0 p-6 flex flex-col justify-end">
                    <h3 className="title-green xl:text-[40px] xl:leading-[52px] lg:text-[36px] lg:leading-[46px] font-bold text-left absolute left-0 top-0 p-[32px_24px] max-w-[432px]">
                      {card.title}
                    </h3>

                    <ul className="lg:max-w-[85%] xl:text-[18px] xl:leading-[25.2px] lg:text-[16px] lg:leading-[22.4px] font-semibold text-white flex flex-wrap justify-start items-start text-left list-none pl-0">
                      {card.tags.map((tag: string, i: number) => (
                        <li
                          key={i}
                          className="after:content-['|'] after:px-2 last:after:content-['']"
                        >
                          {tag}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile */}
        <div className="block sm:hidden">
          <MobileSlider>
            {cards.map((card: any, index: number) => (
              <div key={card.id ?? index} className="card-main">
                <div className="relative border-1 h-[517px] border-[rgba(64,66,76,1)] p-[32px_24px] group overflow-hidden">
                  {card.imageUrl && (
                    <Image
                      src={toWebp(`${baseUrl}${card.imageUrl}`)}
                      alt={card.title}
                      width={1000 * 2}
                      height={500 * 2}
                      quality={100}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  )}

                  <div
                    className="absolute inset-0 border border-[rgba(64,66,76,1)]
                    bg-[linear-gradient(180deg,#000000_0%,rgba(0,0,0,0)_50%),linear-gradient(180deg,rgba(0,0,0,0)_19.88%,#000000_100%)]"
                  />

                  <div className="absolute inset-0 p-6 flex flex-col justify-end">
                    <h3 className="title-green text-heading-3 font-bold text-left absolute left-0 top-0 p-[32px_24px] max-w-[432px]">
                      {card.title}
                    </h3>

                    <ul className="text-subtitle-2 text-white flex flex-wrap justify-start items-start text-left list-none pl-0">
                      {card.tags.map((tag: string, i: number) => (
                        <li
                          key={i}
                          className="after:content-['|'] after:px-2 last:after:content-['']"
                        >
                          {tag}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </MobileSlider>
        </div>
      </div>
    </section>
  );
};

export default TechnologyExpertise;
